query SearchIntegrationJobs(
  $workspaceId: ID!
  $audienceId: String
  $status: String
) {
  searchIntegrationJobs(
    workspaceId: $workspaceId
    audienceId: $audienceId
    status: $status
  ) {
    result {
      completedAt
      createdAt
      displayName
      jobRunId
      metadata
      progress
      status
    }
  }
}
